import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=b3d1db56&scoped=true&"
import script from "./ImageUploader.ts?vue&type=script&lang=ts&"
export * from "./ImageUploader.ts?vue&type=script&lang=ts&"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=b3d1db56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d1db56",
  null
  
)

component.options.__file = "ImageUploader.vue"
export default component.exports